import _404 from 'src/app/404/routes';
import _403 from 'src/app/403/routes';

export const routes = [
  ..._404,
  ..._403,
  {
    name: 'Pair',
    path: '/client/pair',
    component: () => import(/* webpackChunkName: "chat" */ 'pages/Client/Pair'),
    meta: { available: true },
    children: [
      {
        path: ':token',
        meta: { available: true },
      },
    ],
  }, {
    name: 'login',
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ 'pages/Login'),
    meta: { available: true },
  }, {
    name: 'OAuth',
    path: '/session/oauth',
    component: () => import(/* webpackChunkName: "chat" */ 'pages/Session/OAuth'),
    meta: { available: true },
  }, {
    name: 'operator',
    path: '/operator',
    component: () => import(/* webpackChunkName: "operator" */ 'pages/Operator/Index'),
    meta: { auth: ['operator'] },
  }, {
    name: 'crmDemo',
    path: '/crmDemo',
    component: () => import(/* webpackChunkName: "operator" */ 'src/pages/Operator/CrmDemo'),
    meta: { available: true },
  }, {
    name: 'demo',
    path: '/demo',
    component: () => import(/* webpackChunkName: "demo" */ 'src/pages/Client/Demo'),
    meta: { available: true },
  }, {
    name: 'demoTest',
    path: '/demoTest',
    component: () => import(/* webpackChunkName: "demo" */ 'src/pages/Client/DemoChatTest'),
    meta: { available: true },
  }, {
    name: 'demoChannel',
    path: '/demo/:channelName',
    component: () => import(/* webpackChunkName: "demo" */ 'src/pages/Client/Demo'),
    meta: { available: true },
  }, {
    name: 'chatWidget',
    path: '/chat-widget',
    component: () => import(/* webpackChunkName: "chat" */ 'src/pages/Client/ChatWidget'),
    meta: { available: true },
  }, {
    name: 'overseer',
    path: '/overseer',
    redirect: { name: 'Operators' },
    component: () => import(/* webpackChunkName: "overseer" */ 'pages/Overseer/Index'),
    meta: { auth: ['overseer'] },
    children: [
      {
        name: 'Operators',
        path: 'operators',
        component: () => import(/* webpackChunkName: "overseer" */ 'pages/Overseer/Operators'),
        meta: { auth: ['overseer'] },
      }, {
        name: 'SearchActivities',
        path: 'search-activities',
        component: () => import(/* webpackChunkName: "overseer" */ 'src/components/SearchActivities.vue'),
        meta: { auth: ['overseer'] },
      }, {
        name: 'MonitoringActivities',
        path: 'monitoring-activities',
        component: () => import(/* webpackChunkName: "overseer" */ 'pages/Overseer/MonitoringActivities'),
        meta: { auth: ['overseer'] },
      }, {
        name: 'ResultsSurveys',
        path: 'results-surveys',
        component: () => import(/* webpackChunkName: "overseer" */ 'pages/Overseer/ResultsSurveys'),
        meta: { auth: ['overseer'] },
      }, {
        name: 'ActivitiesReport',
        path: 'activities-report',
        component: () => import(/* webpackChunkName: "overseer" */ 'pages/Overseer/ActivitiesReport'),
        meta: { auth: ['overseer'] },
      }, {
        name: 'QueuesReport',
        path: 'queues-report',
        component: () => import(/* webpackChunkName: "overseer" */ 'pages/Overseer/QueuesReport'),
        meta: { auth: ['overseer'] },
      }, {
        name: 'EmploymentOfOperatorsReport',
        path: 'employments-report',
        component: () => import(/* webpackChunkName: "overseer" */ 'pages/Overseer/EmploymentReport'),
        meta: { auth: ['overseer'] },
      },
    ],
  }, {
    name: 'ent_admin',
    path: '/admin',
    component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Index'),
    redirect: { name: 'users' },
    meta: { auth: ['ent_admin'] },
    children: [
      {
        name: 'users',
        path: '/admin/user',
        component: () => import(/* webpackChunkName: "admin" */ 'src/pages/Admin/Users/Users'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'add_user',
        path: '/admin/user/add',
        component: () => import(/* webpackChunkName: "admin" */ 'src/pages/Admin/Users/AddUser'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'edit_user',
        path: '/admin/user/edit/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'src/pages/Admin/Users/EditUser'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'skills',
        path: '/admin/skill',
        component: () => import(/* webpackChunkName: "admin" */ 'src/pages/Admin/SkillsList/Skills'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'add_skill',
        path: '/admin/skill/add',
        component: () => import(/* webpackChunkName: "admin" */ 'src/pages/Admin/SkillsList/AddSkill'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'edit_skill',
        path: '/admin/skill/edit/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'src/pages/Admin/SkillsList/EditSkill'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'SkillsDirectories',
        path: '/admin/skillsdirectories',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/SkillsDirectories/SkillsDirectories'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'SkillsDirectoryItem',
        path: '/admin/skillsdirectories/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/SkillsDirectories/SkillsDirectoryItem'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'add_answer_template',
        path: '/admin/template/add',
        component: () => import(/* webpackChunkName: "admin" */ 'src/pages/Admin/AnswerTemplates/AddAnswerTemplate'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'edit_answer_template',
        path: '/admin/template/edit/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'src/pages/Admin/AnswerTemplates/EditAnswerTemplate'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'answer_templates',
        path: '/admin/template',
        component: () => import(/* webpackChunkName: "admin" */ 'src/pages/Admin/AnswerTemplates/AnswerTemplates'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'absence_reasons',
        path: '/admin/reason',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/AbsenceReasons/AbsenceReasons'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'add',
        path: '/admin/reason/add',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/AbsenceReasons/EditAbsenceReason'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'edit',
        path: '/admin/reason/edit/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/AbsenceReasons/EditAbsenceReason'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'ChannelList',
        path: '/admin/channel',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Channels/ChannelList'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'ChannelItem',
        path: '/admin/channel/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Channels/ChannelItem'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'DirectoriesList',
        path: '/admin/interest',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Interests/DirectoriesList'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'Directory',
        path: '/admin/interest/directory/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Interests/Directory'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'Marker',
        path: '/admin/interest/marker/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Interests/Marker'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'ChannelsGroupList',
        path: '/admin/groups',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/ChannelsGroups/ChannelsGroupList'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'ChannellGroupItem',
        path: '/admin/group/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/ChannelsGroups/ChannellGroupItem'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'Teams',
        path: '/admin/team',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Teams/Teams'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'AddTeam',
        path: '/admin/team/add',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Teams/TeamItem'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'TeamItem',
        path: '/admin/team/edit/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Teams/TeamItem'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'UnitsDepartments',
        path: '/admin/departments',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/UnitsDepartments/UnitsDepartments'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'UnitsDepartmentsItem',
        path: '/admin/departments/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/UnitsDepartments/UnitsDepartmentsItem'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'AllowedDomainsEdit',
        path: '/admin/departments/domainsEdit',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/UnitsDepartments/AllowedDomainsEdit'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'ActivityNotifications',
        path: '/admin/notifications',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/ActivityNotifications/ActivityNotifications'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'ActivityNotificationsItem',
        path: '/admin/notifications/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/ActivityNotifications/ActivityNotificationsItem'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'Timeouts',
        path: '/admin/timeouts',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Timeouts/Timeouts'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'TimeoutsItem',
        path: '/admin/timeouts/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Timeouts/TimeoutsItem'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'Magnets',
        path: '/admin/magnets',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Magnets/Magnets'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'MagnetItem',
        path: '/admin/magnets/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Magnets/MagnetItem'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'Security',
        path: '/admin/security',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Security/Security'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'Intents',
        path: '/admin/intent',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Intents/Intents'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'AddIntent',
        path: '/admin/intent/add',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Intents/IntentItem'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'IntentItem',
        path: '/admin/intent/edit/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Intents/IntentItem'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'Integration',
        path: '/admin/integration',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Integration/Integration'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'EditIntegration',
        path: '/admin/integration/change',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Integration/EditIntegration'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'AddUcceMrd',
        path: '/admin/integration/add',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Integration/UcceMrdItem'),
        meta: { auth: ['ent_admin'] },
      },
      {
        name: 'UcceMrdItem',
        path: '/admin/integration/edit/:id',
        component: () => import(/* webpackChunkName: "admin" */ 'pages/Admin/Integration/UcceMrdItem'),
        meta: { auth: ['ent_admin'] },
      },
    ],
  }, {
    path: '*',
    redirect: '/login',
  },
];

export const beforeEach = (to, _from, next) => {
  if (process.env.APP_BUILD_ENV === 'ttk') {
    if (to.name !== 'Agent') next({ name: 'Agent' });
    else next();
  } else {
    next();
  }
};
